module.exports = [{
      plugin: require('/Users/cjhowe7/src/cjhowe7.github.io/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/cjhowe7/src/cjhowe7.github.io/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
